import { sum, mean, median, max, min, evaluate } from "mathjs";

// Formata valores conforme o tipo e padrão brasileiro
export function formatValue(value: unknown): string {
  if (typeof value === "number") {
    if (Number.isInteger(value)) {
      return value.toLocaleString("pt-BR");
    }
    return value.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }
  if (typeof value === "boolean") {
    return value ? "Sim" : "Não";
  }
  if (typeof value === "string") {
    const date = new Date(value);
    if (!isNaN(date.getTime()) && value.length >= 8 && value.length <= 25) {
      return date.toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    }
    return value;
  }
  if (value instanceof Date) {
    return value.toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }
  if (Array.isArray(value)) {
    return value.join(", ");
  }
  if (typeof value === "object" && value !== null) {
    return JSON.stringify(value);
  }
  return value !== undefined && value !== null ? String(value) : "";
}

// Alinhamento de célula conforme o tipo de valor
export function getCellAlignment(value: unknown): "left" | "right" | "center" {
  if (typeof value === "number") return "right";
  if (typeof value === "string") {
    const date = new Date(value);
    if (!isNaN(date.getTime()) && value.length >= 8 && value.length <= 25) {
      return "right";
    }
    return "left";
  }
  if (typeof value === "boolean") return "left";
  if (value instanceof Date) return "right";
  return "left";
}

// Estatísticas matemáticas para uma coluna numérica
export function getMathStats(
  col: string,
  sortedData: Record<string, unknown>[]
): { [s: string]: unknown } {
  const values = sortedData
    .map(row => row[col])
    .filter(v => typeof v === "number" && !isNaN(v)) as number[];

  if (values.length === 0) {
    return {
      soma: "N/A",
      média: "N/A",
      mediana: "N/A",
      máximo: "N/A",
      mínimo: "N/A",
      contagem: 0,
    };
  }

  return {
    soma: sum(values),
    média: mean(values),
    mediana: median(values),
    máximo: max(values),
    mínimo: min(values),
    contagem: values.length,
  };
}

// Aplica colunas calculadas
export function applyCalcCols(
  paginatedData: Record<string, unknown>[],
  calcCols: { name: string; expr: string }[]
) {
  if (!calcCols.length) return paginatedData;
  return paginatedData.map(row => {
    const newRow = { ...row };
    calcCols.forEach(col => {
      try {
        const scope: Record<string, unknown> = {};
        Object.keys(row).forEach(key => {
          scope[key] = row[key];
        });
        (newRow as Record<string, unknown>)[col.name] = evaluate(col.expr, scope);
      } catch (e) {
        (newRow as Record<string, unknown>)[col.name] = "Erro";
      }
    });
    return newRow;
  });
}